var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAuditoryShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 56,
    viewBox: "0 0 248 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.819 25.9665V28.2721C150.816 33.6763 148.943 38.9347 145.48 43.2631C142.017 47.5915 137.15 50.758 131.604 52.2903C126.058 53.8225 120.13 53.6385 114.705 51.7657C109.28 49.8929 104.648 46.4315 101.5 41.8979C98.3524 37.3643 96.8573 32.0013 97.2378 26.6088C97.6184 21.2163 99.8542 16.0833 103.612 11.9751C107.369 7.867 112.448 5.00394 118.089 3.81295C123.73 2.62196 129.632 3.16686 134.915 5.36637",
    stroke: "#8B5CF6",
    strokeWidth: 3.1656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.955 25.7663L124.001 33.2846L150.821 8.22363",
    stroke: "#8B5CF6",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAuditoryShield);
export default __webpack_public_path__ + "static/media/icon-auditory-shield.e2e82b2bb5570dbdbc8805a6ad60f035.svg";
export { ForwardRef as ReactComponent };